<template>
  <div class="wrapper">
    <p style="text-transform: uppercase;">{{ question }}</p>
    <div class="vote-form">
      <div class="form-prompt">
        <p style="text-transform: uppercase; font-weight: bold;">Select One</p>
      </div>
      <form class="form" v-on:submit.prevent="submitData">
        <div class="form-border">
          <p class="form-title">
            <strong>{{ title }}</strong>
          </p>
          <fieldset>
            <div
              v-for="(response, index) in responses"
              :key="index"
              class="form__field"
            >
              <input
                type="radio"
                name="vote"
                :id="index"
                :value="index"
                v-model="userVote"
                :checked="userVote"
              />
              <label :for="index">{{ response }}</label>
            </div>
          </fieldset>
        </div>
        <div class="form-submit">
          <button class="button__submit" type="submit">
            <span class="button__text">VOTE</span>
            <span class="button__icon">&rarr;</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.ngv.vic.gov.au/custom/we-change-the-world/"
    : "http://localhost:8120/";
export default {
  data() {
    return {
      title: "",
      question: "",
      responses: [],
      votes: [],
      userVote: null,
    };
  },
  props: ["formId"],
  methods: {
    async fetchData() {
      const status = (response) => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      };

      const json = (response) => {
        return response.json();
      };

      await fetch(BASE_URL + "get", { cache: "no-cache" })
        .then(status)
        .then(json)
        .then((data) => {
          this.title = data[this.formId].title;
          this.question = data[this.formId].question;
          this.responses = data[this.formId].responses;
          this.votes = data[this.formId].votes;
        })
        .catch((error) => {
          console.log("Request failed", error);
        });
    },
    async submitData() {
      const status = (response) => {
        if (response.status >= 200 && response.status < 300) {
          return Promise.resolve(response);
        } else {
          return Promise.reject(new Error(response.statusText));
        }
      };

      const json = (response) => {
        return response.json();
      };

      const url = new URL(BASE_URL + "set");
      const params = { id: this.formId, vote: this.userVote };

      url.search = new URLSearchParams(params).toString();

      await fetch(url, { method: "POST", cache: "no-cache" })
        .then(status)
        .then(json)
        .then((data) => {
          /* @TODO: call function that transitions to animation */
          console.log(data);

          this.swapForm();
        })
        .catch((error) => {
          console.log("POST failed", error);
        });
    },
    swapForm() {
      this.$emit('dismissed', 'form');
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.vote-form {
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 5em;
}
.form-submit {
  text-align: right;
}
.form-prompt {
  text-align: left;
}
.form-prompt p {
  margin: 0;
  padding: 1em;
  border: 2px solid var(--color-black);
  border-bottom: 0;
  display: inline-block;
  font-weight: bold;
  color: var(--color-black);
}
.form-title {
  margin: 0;

  padding: 1em;
  background-color: var(--color-black);
  color: #ffffff;
  font-size: 2em;
}
.form {
  font-weight: bold;
}
.form-border {
  border: 2px solid var(--color-black);
}
fieldset {
  border: none;
  padding: 0;
  margin: 0;
}
.form__field {
  display: grid;
  border-bottom: 2px solid var(--color-black);
}
.form__field:last-child {
  border: 0;
}
input[type="radio"] {
  display: none;
}
label {
  padding: 1.25em;
  text-align: left;
  background-color: var(--color-white);
  color: var(--color-black);
  cursor: pointer;
  transition: 0.3s ease;
  font-size: 1.25em;
}

label:hover {
  background-color: var(--color-black-light);
  color: var(--color-white);
}
input[type="radio"]:checked + label {
  background-color: var(--color-black);
  color: var(--color-white);
}
input[type="radio"]:checked + label:hover {
  background-color: var(--color-black-label);
  color: var(--color-white);
}
.button__submit {
  padding: 1em;
  border: 2px solid var(--color-black);
  border-top: none;

  background-color: var(--color-black);
  color: var(--color-white);

  text-transform: uppercase;
  font-weight: bold;
  font-size: 1em;

  cursor: pointer;
  transition: 0.3s ease;
}
.button__submit:hover {
  background-color: var(--color-black-light);
  color: var(--color-white);
}
.button__icon {
  display: inline-block;
  transform: translateX(0);
  transition: 0.3s ease;
}
.button__submit:hover > .button__icon {
  transform: translateX(3px);
}
</style>
